<div class="asset-cell-wrapper" (click)="block($event)" (mousedown)="block($event)">
  <ng-select
    [items]="assetList"
    bindLabel="name"
    bindValue="name"
    [(ngModel)]="selectedAssets"
    [multiple]="true"
    [searchable]="true"
    [closeOnSelect]="false"
    [appendTo]="'body'"
    placeholder="Select Assets"
  >
 
    <!-- ✅ SELECT ALL -->
    <ng-template ng-header-tmp>
      <div class="option-row" (click)="toggleSelectAll()">
        <input
          type="checkbox"
          [checked]="isAllSelected()"
          (click)="toggleSelectAll();$event.stopPropagation()"
        />
        <span>Select All</span>
      </div>
    </ng-template>
 
    <!-- ✅ OPTIONS -->
    <ng-template ng-option-tmp let-item="item">
      <div class="option-row">
        <input
          type="checkbox"
          [checked]="selectedAssets.includes(item.name)"
          (click)="$event.stopPropagation()"
          (change)="toggleItem(item)"
        />
        <span>{{ item.name }}</span>
      </div>
    </ng-template>
 
    <!-- ✅ SINGLE LABEL for MULTI SELECT (A +2) -->
    <ng-template ng-multi-label-tmp let-items="items">
      <span *ngIf="items?.length === 0">Select Assets</span>
      <span *ngIf="items?.length === 1">
        {{ (items[0]?.name || items[0]) }}
      </span>
      <span *ngIf="items?.length > 1">
        {{ (items[0]?.name || items[0]) }} +{{ items.length - 1 }}
      </span>
    </ng-template>
 
  </ng-select>
</div>